import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";

import { AuthProvider } from "./context/AuthContext.tsx";
import { AxiosPrivateProvider } from "./hooks/useAxiosPrivate.tsx";

const rootElement =
	document.getElementById("root") || document.createElement("div");
ReactDOM.createRoot(rootElement).render(
	<BrowserRouter basename="/nb">
		<AuthProvider>
			<AxiosPrivateProvider>
				<Routes>
					<Route path="/*" element={<App />} />
				</Routes>
			</AxiosPrivateProvider>
		</AuthProvider>
	</BrowserRouter>,
);
